var url = require('url');
var https = require('https');

var jquery = require("jquery");
window.$ = window.jQuery = jquery; // notice the definition of global variables here

class WMS{
	data(type,input={},callback){
	
		var that = this;
		var date = new Date();
		var year = date.getFullYear();
		var exportdata;
		let urlSett = {};
		
		// default query
		var query = {
				//layer: 	'MOISTURE_INDEX',
				layer: 	'MOISTURE_INDEX2',
				STYLE:	'INDEX',
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX:	'1516510,5769466,1516511,5769465',
				RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				BINS:	100		
			};
			
		// input can overwrite default
		const merge = Object.assign(query, input);

		if(query.layer != "LST_LANDSAT_FLOAT"){
			urlSett = {
				protocol: 'https',
				hostname: 'services.sentinel-hub.com',
				pathname: 'ogc/fis/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23',
				query: merge
			};
		}else{
			urlSett ={
				protocol: 'https',
				hostname: 'services-uswest2.sentinel-hub.com',
				pathname: 'ogc/fis/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23',
				query: merge
			};
		}
		
		const requestUrl = url.parse(url.format(urlSett));
		
		// TODO - replace listener with callback for "WMS_slider"
		const req = https.get({
					hostname: requestUrl.hostname,
					path: requestUrl.path,
				}, (res) => {
					
					let chunk_data = "";
					
					res.on('data', function (chunk) {
							chunk_data += chunk;
					  });
					  
					res.on("end", function(){
						
						exportdata = JSON.parse(chunk_data);
						
						if(type == "WMS_slider"){
							exportdata = that.constructor.extractDates(exportdata);
						}
						
						$(document).trigger(type, [exportdata]);
						
						if(type == "WMS_point"){		
							if(callback) callback(exportdata);
						}
					});
				});
	}
	
	mdata(input={},callback){
		const results = [];	
		var exportdata;
			
		const list = this.wms_list();
		const list_size = list.length;
		
		let j = 0;
			
		// 1. Make multiple AJAX calls to a Server
		for(var i in list){
			
			// input can overwrite default
			const merge = Object.assign(list[i], input);
			
			const requestUrl = url.parse(url.format({
				protocol: 'https',
				hostname: 'services.sentinel-hub.com',
				pathname: 'ogc/fis/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23',
				query: merge,
			}));
			
			https.get({
					hostname: requestUrl.hostname,
					path: requestUrl.path,
				}, (res) => {
					
					let chunk_data = "";
					
					res.on('data', function (chunk) {
							chunk_data += chunk;
					  });
					  
					res.on("end", function(){
						exportdata = JSON.parse(chunk_data);
						
						//??
						/*
						$(document).trigger(type, [exportdata]);
						
						if(type == "WMS_point"){		
							if(callback) callback(exportdata);
						}
						*/
						
						results.push(exportdata);
						if(list_size == (j+1)){
							if(callback) callback(results);
						}
					});
				});	
			j++;
		}				
	}
	
	// old sentinel-hub API - deprecated
	jdata(input={},callback){
		var exportdata;
			
		const list = this.wms_list();	

		let results = {};
		let deferred;
		let deferreds = [];
			
		// 1. Make multiple AJAX calls to a Server
		for(var i in list){			
			// input can overwrite default
			const merge = Object.assign(list[i], input);
			
			// set URL
			let url = "";
			if(list[i].layer == "LST_LANDSAT_FLOAT"){
				url = "https://services-uswest2.sentinel-hub.com/ogc/fis/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23";
			}else{
				url = "https://services.sentinel-hub.com/ogc/fis/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23";
			}
									
			// jquery get
			deferred = $.get(url, merge, function(data){
				
				let url = new URL(this.url);
				let layer = url.searchParams.get("layer");
								
				results[layer] = data;
			});
			
			deferreds.push(deferred);			
		}		

		$.when.apply($, deferreds).then(function() {
		  if(callback) callback(results);
		});
	}
	
	jdata2(input={},callback){					
		var that = this;
		
		const list = this.wms_list2('list');	

		let results = {};
		let deferred;
		let deferreds = [];
			
		// 1. Make multiple AJAX calls to a Server
		for(var i in list){	
			var that = this;
			
			// load default properties
			
			let url = "https://services.sentinel-hub.com/api/v1/statistics";
			var props = this.wms_list2('json');
			
			// set type to landsat
			if(list[i] == "LST_LANDSAT_FLOAT"){
				props.input.data[0].type = 'landsat-ot-l1';
				url = "https://services-uswest2.sentinel-hub.com/api/v1/statistics";
			}
			
			const prop = that.deepMerge(props,input);
			
							
			// jquery post			
			 deferred = $.ajax({
				  url: "https://app.gis.si/proxy/sentinel.php",
				  method: 'POST',
				  contentType: "application/json",
					context: {id: list[i]},
				  data: JSON.stringify({
						evalscript: that.evalscript_list(list[i]),
						request: prop,
						url: url
				  }), // Convert the object to a JSON string
					success: function(data) {
						results[this.id] = data;
					},				  
				});
									
			deferreds.push(deferred);			
		}		

		$.when.apply($, deferreds).then(function() {
		  if(callback) callback(results);
		});
	}
	
	wms_list2(mode){
		const list = ['NMDI_FLOAT', 'MOISTURE_INDEX2', 'NDVI_FLOAT', 'LST_LANDSAT_FLOAT'];
		
		const def_prop = {
				  "input": {
					"bounds": {
					  "bbox": [1534497, 5763409, 1534498, 5763410],
					  "properties": {
						"crs": "http://www.opengis.net/def/crs/EPSG/0/3857"
					  }
					},
					"data": [
					  {
						"type": "sentinel-2-l1c",
						"dataFilter": {
						  "maxCloudCoverage": 70,
						  "mosaickingOrder": "leastRecent"
						}
					  }
					]
				  },
				  "aggregation": {
					"timeRange": {
					  "from": "2026-01-10T00:00:00Z",
					  "to": "2026-02-09T23:59:59Z"
					},
					"aggregationInterval": {
						"of": "P1D"
					},
					"resx": "10",
					"resy": "10"
				  },				  
				};
		
		// classic api version
		/*
		const def_prop = {
				  "input": {
					"bounds": {
					  "bbox": [1534497, 5763409, 1534498, 5763410],
					  "properties": {
						"crs": "http://www.opengis.net/def/crs/EPSG/0/3857"
					  }
					},
					"data": [
					  {
						"type": "sentinel-2-l2a",
						"dataFilter": {
						  "maxCloudCoverage": 70,
						  "mosaickingOrder": "leastRecent",
						  "timeRange": {
							  "from": "2026-01-10T00:00:00Z",
							  "to": "2026-02-09T23:59:59Z"
							},
						}
					  }
					]
				  },
					"output": {
						"resx": 20,
						"resy": 20
					  }
				};
		*/
		
		return (mode == 'list') ? list : def_prop;
	}
	

	// updates main JSON (target) with JSON subset update (source)
	deepMerge(target, source) {
	  for (const key in source) {
		if (
		  source[key] &&
		  typeof source[key] === "object" &&
		  !Array.isArray(source[key])
		) {
		  target[key] = this.deepMerge(target[key] ?? {}, source[key]);
		} else {
		  target[key] = source[key];
		}
	  }
	  return target;
	}
	
	evalscript_list(key){
		
		var list = {
			"NMDI_FLOAT": `
				//VERSION=3
				
				function evaluatePixel(sample) {
				  let value = (sample.B8A - (sample.B11 - sample.B12)) / (sample.B8A + (sample.B11 - sample.B12)); 
				  
				   if(sample.CLM == 1){
					value = "false";
				  }
				  
				  return {"moisture": [value],
							"dataMask": [sample.dataMask]
				  };
				}

				function setup() {
				  return {
					input: [{
					  bands: [
						"B8A",
						"B11",
						"B12",
						"dataMask",
						"CLM"
					  ]
					}],
					output: [
					  { id: "moisture", bands: 1, sampleType: "FLOAT32" },
					  { id: "dataMask", bands: 1 }
					]
				  }
				}
				`,
			"NDVI_FLOAT": `
				//VERSION=3
				function setup() {
				  return {
					input: [{ bands: ["B04",
										"B08",
										"dataMask",
										"CLM"] }],
					output: [
					  { id: "moisture", bands: 1, sampleType: "FLOAT32" },
					  { id: "dataMask", bands: 1 }
					]
				  };
				}

				function evaluatePixel(sample) {
					let value = index(sample.B08, sample.B04);
					
					 if(sample.CLM == 1){
							value = "false";
						  }
					
				  return {
					moisture: [value],
					dataMask: [sample.dataMask]
				  };
				}
				`,
			"MOISTURE_INDEX2": `
				//VERSION=3

				function evaluatePixel(sample) {
				  let value = index(sample.B8A, sample.B11);
				  
				  if(sample.CLM == 1){
					value = "false";
				  }
				  
				  return {"moisture": [value],
							"dataMask": [sample.dataMask]
				  };
				}
				function setup() {
				  return {
					input: [{
					  bands: [
						"B8A",
						"B11",
						"dataMask",
						"CLM"
					  ]
					}],
					output: [
					  { id: "moisture", bands: 1, sampleType: "FLOAT32" },
					  { id: "dataMask", bands: 1 }
					]
				  }
				}
				`,
			"LST_LANDSAT_FLOAT": `
				//VERSION=3
				let minVal = 200;
				let maxVal = 375;


				function evaluatePixel(samples) {
					let val = samples.B10;
					val = val - 273.15;
				  
					if(decodeL8C2Qa(samples.BQA).cloud == 1)
					{
					  val = "false";
					}
				   
				  return {"moisture": [val],
							"dataMask": [samples.dataMask]
				  };    
				}

				function setup() {
				  return {
					input: [{
					  bands: [
						"B10",
						"BQA",
						"dataMask"
					  ]
					}],
					output: [
					  { id: "moisture", bands: 1, sampleType: "FLOAT32" },
					  { id: "dataMask", bands: 1 }
					]
				  }
				}

				`
			
		};
		
		return list[key];
	
	}
	
	// sentinel-hub list structured for old API, but still in use
	wms_list(){
		
		var date = new Date();
		const year = date.getFullYear();
		
		// layer name/title attribute must be defined in sentinel-hub portal user settings
		// this list is used for gathering data by chart display
		const list = [
			{
				// NDMI - vlaga,
				layer: 	'MOISTURE_INDEX2',
				STYLE:	'INDEX',
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX:	'1516510,5769466,1516511,5769465',
				RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				BINS:	100		
			},		
			{
				// NDVI - vegetacija
				layer: 	'NDVI_FLOAT',
				STYLE:	'INDEX',
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX:	'1516510,5769466,1516511,5769465',
				RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				BINS:	100		
			},
			{
				// NVDI - suša
				layer: 	'NMDI_FLOAT',
				STYLE:	'INDEX',
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX:	'1516510,5769466,1516511,5769465',
				RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				BINS:	100		
			},
			{
				// LST - temperature
				layer: 	'LST_LANDSAT_FLOAT',
				STYLE:	'INDEX',
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX:	'1516510,5769466,1516511,5769465',
				RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				BINS:	100		
			}
		];
		
		return list;
	}
			
	static extractDates(data){
		var objekt;
		var dates = [];
		if(data.hasOwnProperty("C0")){		
			objekt = data["C0"];
		}else if(data[Object.keys(data)[0]]){
			objekt = data[Object.keys(data)[0]];
		}else{	// empty data case
			return [];
		}
			
		objekt.forEach(function(subject){
			dates.push(subject["date"]);
		});
		
		return dates;
	}
}
		
export {WMS};